import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./Pages/Work/Work";
import Info from "./Pages/Info/Info";
import Loading from "./Pages/Loading/Loading";
import Projects from "./Pages/Projects/Projects";
import Projects2 from "./Pages/Projects/Projects2";
import Projects3 from "./Pages/Projects/Projects3";
import Projects4 from "./Pages/Projects/Projects4";
import Blogs from "./Pages/Blogs/Blogs";
import BlogDetail from "./Pages/Blogs/BlogDetail";
import Scrolltotop from "./Components/Scrolltotop";
import MoreProjects from "./Pages/MoreProjects/MoreProjects";
import NotFound from "./Pages/NotFound/NotFound";
import WhatsAppIcon from "./Assets/WhatsAppIcon.png";
import CustomCursor from "./Components/CustomCursor";
import CookieConsent from "react-cookie-consent";
import PrivacyPolicy from "./Components/Footer/PrivacyPolicy"; // Corrected path
import TermsConditions from "./Components/Footer/TermsConditions"; // Corrected path

function AppContent() {
  const location = useLocation();
  const isLoadingPage = location.pathname === "/";

  return (
    <div className="App">
      <CustomCursor />
      <Scrolltotop />
      <Routes>
        <Route path="/" element={<Loading />} />
        <Route path="/home" element={<Home />} />
        <Route path="/info" element={<Info />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects-2" element={<Projects2 />} />
        <Route path="/projects-3" element={<Projects3 />} />
        <Route path="/projects-4" element={<Projects4 />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/more-projects" element={<MoreProjects />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {!isLoadingPage && (
        <>
          <a
            href="https://wa.me/94713775404?text=Hi%20Minuri%2C%20I%20would%20like%20to%20chat%20about%20your%20services."
            target="_blank"
            rel="noreferrer"
            className="whatsapp-float"
            aria-label="Open WhatsApp chat"
          >
            <img src={WhatsAppIcon} alt="WhatsApp" className="whatsapp-float-icon" />
          </a>
        </>
      )}
      <CookieConsent
        location="bottom"
        buttonText="Accept All"
        declineButtonText="Decline"
        enableDeclineButton
        expires={150}
        style={{ background: "#ffffff", color: "black", bottom: "80px", zIndex: 9999 }}
        buttonStyle={{ background: "#000000", color: "white", borderRadius: "8px", height: "48px", padding: "0 20px" }}
        declineButtonStyle={{ background: "transparent", border: "1px solid black", color: "black", borderRadius: "8px", height: "48px", padding: "0 20px" }}
        buttonClasses="cookie-consent-button"
        declineButtonClasses="cookie-consent-decline-button"
        buttonWrapperClasses="cookie-consent-button-wrapper"
      >
        We use cookies to enhance your experience on minuri.me. By clicking Accept All, you agree to our use of cookies.
      </CookieConsent>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
